<div class="spa-navigation">
  <spa-app-navigation [routes]="routes()" />

  <div class="spa-navigation__footer">
    @if (presenter.viewState().user; as user) {
      <div class="spa-navigation__user" role="img" [attr.aria-label]="user.name" [title]="user.name">
        <span class="spa-navigation__avatar">
          @if (user.avatarSrc) {
            <img [alt]="user.name" [src]="user.avatarSrc" />
          } @else {
            <spa-icon fontSize="32px">person</spa-icon>
          }
        </span>
      </div>
    }

    <spa-backend-toggle [labelAboveToggle]="true" />

    @if (presenter.viewState().logout; as logout) {
      <button
        class="spa-navigation__logout"
        type="button"
        [attr.aria-label]="logout.label"
        [title]="logout.label"
        (click)="onLogout()"
      >
        <spa-icon fontSize="32px">{{ logout.icon }}</spa-icon>
      </button>
    }
  </div>
</div>
